import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid,
  TextField,
  Typography,
  Alert
} from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { updateUserCredentials } from '../services/api';

const ConfigurationPage: React.FC = () => {
  const { user } = useAuth();
  
  const [externalUserId, setExternalUserId] = useState('');
  const [externalAuthToken, setExternalAuthToken] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const handleUpdateCredentials = async (e: React.FormEvent) => {
    e.preventDefault();
    
    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const updateData: {
        external_user_id?: string;
        external_auth_token?: string;
      } = {};
      
      if (externalUserId) {
        updateData.external_user_id = externalUserId;
      }
      
      if (externalAuthToken) {
        updateData.external_auth_token = externalAuthToken;
      }
      
      await updateUserCredentials(updateData);
      
      setSuccess('Credentials updated successfully');
    } catch (err) {
      console.error('Error updating credentials:', err);
      setError('Failed to update credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Box>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Configuration
      </Typography>
      
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
            User Profile
          </Typography>
          
          <Divider sx={{ mb: 2 }} />
          
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                <strong>Username:</strong> {user?.name}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent>
          <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
            Update Credentials
          </Typography>
          
          <Divider sx={{ mb: 3 }} />
          
          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}
          
          <Box component="form" onSubmit={handleUpdateCredentials}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  Service Provider Credentials
                </Typography>
                
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <TextField
                    label="External User ID"
                    value={externalUserId}
                    onChange={(e) => setExternalUserId(e.target.value)}
                    helperText="Your user ID for Beat81"
                  />
                </FormControl>
                
                <FormControl fullWidth>
                  <TextField
                    label="External Auth Token"
                    value={externalAuthToken}
                    onChange={(e) => setExternalAuthToken(e.target.value)}
                    helperText="Your auth token for Beat81 "
                  />
                </FormControl>
              </Grid>
              
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                  >
                    {loading ? 'Updating...' : 'Update Credentials'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ConfigurationPage; 